export default {
  functionKey: "TEXTE",
  title: "TEXTE",
  group: "Texte",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 1,
  requiredArguments: [{ argumentKey: "Format", name: "Format" }],
  expectedArguments: [
    { name: "Format (ex: 0.00 / €)", argumentKey: "Format", single: true, initialValue: "" }
  ],
  description: "Formate un nombre en texte selon un format. (Ex: TEXTE(1234.5, '0.00') -> '1234.50')",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const fmt = args[0] ?? "''";
    const displayCode = `${destination} = Number(${origin}).toLocaleString('fr-FR', {format: ${fmt}});`;
    const safeCode = `
    if (!isNaN(parseFloat(${origin}))) {
      let _fmt = ${fmt}.replace(/'/g, '');
      let _decimals = (_fmt.split('.')[1] || '').replace(/[^0]/g, '').length;
      ${destination} = Number(${origin}).toFixed(_decimals);
    } else {
      ${destination} = ${origin};
    }`;
    return { displayCode, safeCode };
  }
}
